import React from 'react';
import {reduxForm} from 'redux-form';
import BaseForm from '../form/base-form';
import FormField from '../form/form-field';
import DateField from '../form/date-field';
import LocalizedStrings from '../../localization/strings';
import Button from '../button';
import {validateRequiredFields} from '../../utils/form';
import Alert from '../alert';

const fields = [

    'first_name',
    'last_name',
    'birth_date'
];

function validate(values) {
    let errors = {
        _error: null
    };
    errors = validateRequiredFields(values, [
        'first_name',
        'last_name'
    ], errors);
    return errors;
}

class ParticipantResultHistoryForm extends BaseForm {
    showAlert() {
        return false;
    }

    render() {
        const {
            submitting,
            error,
            handleSubmit,

            fields: {
                first_name,
                last_name,
                birth_date

            }
        } = this.props;
        return (
            <div className="participant-result-history-form">
                <form onSubmit={handleSubmit(this.submit.bind(this))}>
                    {error && <Alert type="error">{error}</Alert>}
                    <div className="form-row">
                        <FormField label={LocalizedStrings.firstName} name="name" field={first_name}>
                            <input ref="name" placeholder={LocalizedStrings.firstName} type="text" {...first_name}/>
                        </FormField>

                        <FormField label={LocalizedStrings.lastName} name="last_name" field={last_name}>
                            <input ref="last_name" placeholder={LocalizedStrings.lastName} type="text" {...last_name}/>
                        </FormField>
                        <FormField label={LocalizedStrings.birthDate} name="birth_date" field={birth_date}>
                            <DateField {...birth_date} timeFormat={false} noTimeZoneDate={true} viewMode="years"/>
                        </FormField>
                    </div>

                    <div className="actions-row">
                        <Button loading={submitting} submit={true} disabled={submitting} type="main-color">
                            {LocalizedStrings.startSearch}
                        </Button>

                    </div>

                </form>
            </div>
        )
    }
}

export default reduxForm({
    form: 'participant-result-history-form',
    fields,
    validate,
    destroyOnUnmount: true
})(ParticipantResultHistoryForm);



// WEBPACK FOOTER //
// ./src/js/components/participant/participant-result-history-form.js